import { ButtonIcon, CustomSelect, InputForm } from '@components/index'
import { FIXED_TABLE_VALUES, ICreateTableSales, IFieldArray, STATUS } from '@interfaces/tables/tableSales'
import React from 'react'
import { FieldArrayWithId, FieldValues, UseFormRegister, useFormContext } from 'react-hook-form'
import { TiDelete } from 'react-icons/ti'

interface IProps {
    columns: IFieldArray[]
    row: FieldArrayWithId<ICreateTableSales, 'rows', 'id'>
    index: number
    register: UseFormRegister<FieldValues>
    remove: (index: number) => void
}

export default function TableSaleRow(props: IProps): React.ReactElement {
    const [rowColor, setRowColor] = React.useState('transparent')
    const { getValues } = useFormContext()
    const status = [
        { title: 'Disponível', value: STATUS.AVAILABLE, color: 'transparent' },
        { title: 'Indisponível', value: STATUS.UNAVAILABLE, color: '#fff9b2' },
        { title: 'Reservado', value: STATUS.RESERVED, color: '#b2ffff' }
    ]

    function onChangeStatus(value?: string): void {
        const rowStatus = status.find(s => s.value === value)
        setRowColor(rowStatus?.color || 'transparent')
    }

    React.useEffect(() => {
        const rows = getValues(`rows.${props.index}.cells`)
        const rowStatus = status.find(s => rows.find((r: IFieldArray) => r.value === s.value))
        onChangeStatus(rowStatus?.value)
    }, [props.row.id])

    return <tr key={props.row.id} style={{ backgroundColor: rowColor }}>
        {props.columns.map((cell, index) => {
            const { ref: inputRef, ...inputProps } = props.register(`rows.${props.index}.cells.${index}.value`)
            const { ref: inputColumnId, ...inputPropColumnId } = props.register(`rows.${props.index}.cells.${index}.columnId`)
            return (
                cell.name !== FIXED_TABLE_VALUES.STATUS ?
                    <td key={cell.id}>
                        <input
                            ref={inputColumnId}
                            {...inputPropColumnId}
                            value={index}
                            type='number'
                            name='columnId'
                            hidden
                        />
                        <InputForm
                            inputRef={inputRef}
                            {...inputProps}
                            type={cell.name === 'Unidade' ? 'number' : 'text'}
                            size='small'
                            style={{
                                backgroundColor: '#fff',
                                borderRadius: '0.25rem'
                            }}
                            inputProps={{ maxLength: 50 }}
                        />
                    </td>
                    :
                    <td key={cell.id}>
                        <input
                            ref={inputColumnId}
                            {...inputPropColumnId}
                            value={index}
                            type='number'
                            name='columnId'
                            hidden
                        />
                        <CustomSelect
                            inputRef={inputRef}
                            propsRegister={inputProps}
                            onChange={(e) => onChangeStatus(e.target.value)}
                            name='realEstate'
                            placeholder='Selecione...'
                            defaultValue={props.row.cells && props.row.cells[index].value ? props.row.cells[index].value : 'none'}
                            options={status}
                            style={{
                                backgroundColor: '#fff',
                                borderRadius: '0.25rem',
                                minWidth: '8rem'
                            }}
                            isFirstNoneDefault
                        />
                    </td>
            )
        })}
        <td className='box-button-delete'>
            <ButtonIcon
                style={{
                    backgroundColor: 'transparent'
                }}
                type='button'
                onClick={() => props.remove(props.index)}
                title='Remover Linha'
            >
                <TiDelete size={25} />
            </ButtonIcon>
        </td>
    </tr>
}